<template>
   <div v-if="formData && config" style="padding: 0 10px;">
      <attendance-item 
         v-for="item of formData"
         :data="item"
         :showError="showError"
         :locale="locale"
         :languages="config.Languages"
         :onChange="(v) => item.value = v"
      />
      <v-btn 
         :color="config.BGColor"
         block
         :style="{ color: config.Color }"
         @click="handleSendForm"
      >
         {{getTranslation(sSend, locale)}}
      </v-btn>
   </div>
   <div v-else-if="showSuccess"
      style="padding: 20px"
   >
      <v-alert
         prominent
         type="success"
         outlined
      >
         <v-row align="center">
           <v-col class="grow">
            {{getTranslation({es: 'Registro creado correctamente.', en: 'Created successfully', de: 'Datensatz erfolgreich erstellt'}, locale)}}
           </v-col>
            <v-col class="shrink">
               <v-btn
                  @click="handleGetForm"
               >
               {{getTranslation({es: 'Nuevo registro', en: 'Add new', de: 'Neue hinzufügen'}, locale)}}
               </v-btn>
           </v-col>
         </v-row>
      </v-alert>
   </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import utils from '@/services/utils'
import AttendanceItem from './AttendanceItem'
export default {
   name:'Item50BookingAttendance',
   components: {
      AttendanceItem,
   },
   props: {
      content: {
         type: Object,
         default: null,
      },
      config: {
         type: Object,
         default: null,
      },
      locale: {
         type: String,
         default: null,
      },
      isDesktop: {
         type: Boolean,
         default: false,
      },
   },
   data: () => ({
      formData: null,
      showSuccess: true,
      showError: false,
   }),
   computed: {
      ...mapState('app', ['dtouchWorkspace']),
      attendanceWorkspaceID () {
         return this.content.AttendanceWorkspaceID
      },
      sSend () {
         return {es: 'enviar', en: 'send', de: 'schicken'}
      },
       cacheFormData () {
         return this.$store.state.app.cacheFormData
       },
   },
   watch: {
      'content.AttendanceWorkspaceID' () {
         this.handleGetForm()
      },
   },
   mounted () {
      this.handleGetForm()
   },
   methods: {
      getTranslation(v, locale) {
         return utils.getTranslation(v, locale)
      },
      handleGetForm () {
         if (!this.attendanceWorkspaceID) return
         const url = `${window.location.protocol}//${process.env.VUE_APP_API_URL_DTOUCH}/v1/public/cm/${this.dtouchWorkspace}/attendance/${this.attendanceWorkspaceID}`
         axios.get(url)
            .then(response => {
               const name = this.cacheFormData ? localStorage.getItem(`f_name`) : null
               const gn = this.cacheFormData ? localStorage.getItem(`f_guardianName`) : null
               const pn = this.cacheFormData ? localStorage.getItem(`f_paxName`) : null

               const guardianName = name && name.length > 0 ? name
                                    : gn && gn.length > 0 ? gn : null
               const paxName = pn && pn.length > 0 ? pn : null
               this.formData = [{
                  Type: 'string',
                  ID: 'guardianName',
                  Name: { es: 'Nombre del padre, madre o tutor', en: 'Name of father, mother or guardian', de: 'Name des Vaters, der Mutter oder des Erziehungsberechtigten', fr: 'Nom du père, de la mère ou du tuteur' },
                  Required: true,
                  IsFixed: true,
                  value: guardianName
               },
               {
                  Type: 'string',
                  ID: 'paxName',
                  Name: { es: 'Nombre del participante', en: 'Name of participant', de: 'Name des Teilnehmers', fr: 'Nom du participant' },
                  Required: true,
                  IsPaxData: true,
                  IsFixed: true,
                  value: paxName
               }]
               this.formData.push(...response.data.map(item => {
                  const aux = this.cacheFormData ? localStorage.getItem(`f_${item.ID}`) : null
                  item.value = aux && aux.length > 0 ? aux : null
                  return item
               }))
               this.showSuccess = true
            })
            .catch((error) => {
               console.log(error)
            })
            .then(() => {
               this.loading = false
            })
      },
      handleSendForm () {
         if (this.formData.filter(x => x.Required && (x.value === null || x.value === undefined)).length > 0) {
            this.showError = true
            alert('Campos requeridos.')
            return
         }
         const values = {}

         for (const item of this.formData) {
            if (window.location.href.indexOf('.dtouch.') > 0) {
               localStorage.setItem(`f_${item.ID}`, item.value)
               if (item.ID === 'guardianName') {
                  localStorage.setItem(`f_name`, item.value)
               }
            }
            if (!item.IsFixed)
               values[item.ID] = item.value && item.value !== undefined ? item.value : null
         }
         const guardianName = this.formData.filter(x => x.ID === 'guardianName').shift()
         const paxName = this.formData.filter(x => x.ID === 'paxName').shift()
         const body = {
            guardianName: guardianName ? guardianName.value : null,
            paxName: paxName ? paxName.value : null,
            values
         }
         const url = `${window.location.protocol}//${process.env.VUE_APP_API_URL_DTOUCH}/v1/public/cm/${this.dtouchWorkspace}/attendance/${this.attendanceWorkspaceID}`
         axios.post(url, body)
            .then(response => {
               alert(utils.getTranslation({es: 'Registro realizado correctamente', en: 'Registration successful', de: 'Registrierung erfolgreich'}, this.locale))
               this.formData = null
               this.showSuccess = true
               // this.handleGetForm()
               this.showError = false
            })
            .catch((error) => {
               console.log(error)
            })
            .then(() => {
               this.loading = false
            })
      },
   },
}
</script>

